import {makeDefaultVuexModule} from "../ModuleFactory";
import * as TYPES from "../types";
import axios from 'axios';
import Vue from 'vue'

const PuntLogsModule = makeDefaultVuexModule('PUNTLOGS', '/puntlogs', 'id', 'DESC');

export default PuntLogsModule;
